const CHECK_DIGIT_INDEX: number = 3;
const WEIGHTS: number[] = [3, 7, 9, 5, 8, 4, 2, 1, 6];

export const isValidSecurityNumber = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }
  
  const sanitized: string = value.replace(/\s/g, '');
  
  if (!/^\d{10}$/.test(sanitized)) {
    return false;
  }
  
  const digits: number[] = sanitized.split('').map(Number);
  const checkDigit: number = digits[CHECK_DIGIT_INDEX];
  
  const weightedDigits: number[] = digits.filter((_: number, index: number): boolean => index !== CHECK_DIGIT_INDEX);
  const checksum: number = weightedDigits.reduce((sum: number, digit: number, index: number): number => sum + digit * WEIGHTS[index], 0);
  const expectedCheckDigit: number = checksum % 11;
  
  if (expectedCheckDigit === 10) {
    return false;
  }
  
  return expectedCheckDigit === checkDigit;
  
}